module.exports = __webpack_public_path__ + "static/media/30.8a399fdc.jpg";